import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgImgPlaceholder = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 2,
		fill: "none",
		stroke: "currentColor",
		strokeLinejoin: "round",
		className: "nc-icon-wrapper",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 18,
				cy: 16,
				r: 4
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-cap": "butt",
				d: "M20.849 33.164 33 20l13 13M2 38l12-11 10 9"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M2 6h44v36H2z" })
		]
	})
});
export default SvgKgImgPlaceholder;
